import type { Richtext } from 'storyblok-js-client';

export function richTextIsEmpty(text?: Richtext) {
  if (!text) {
    return true;
  }

  const stack: Richtext[] = [...text.content];

  while (stack.length) {
    const element = stack.pop();

    if (!element) {
      continue;
    }

    if (element.type === 'text' && element.text?.trim()?.length) {
      return false;
    }

    if (element.content) {
      stack.push(...element.content);
    }
  }

  return true;
}
